import React from "react";
import { LedgerRecord } from "../../../services/interfacev2";
import { useNavigate } from "react-router-dom";

interface Props {
  results: LedgerRecord[];
  onClose: () => void;
}

const LedgerSearchDropdown: React.FC<Props> = ({ results, onClose }) => {
  const navigate = useNavigate();

  if (results.length === 0) {
    return <p className="p-2">No data available</p>;
  }

  const getFullName = (item: LedgerRecord) => {
    const nameParts = [item.firstName, item.middleName, item.lastName].filter((part) => part && part !== "undefined" && part.trim() !== "");

    return nameParts.join(" ") || "Unnamed";
  };

  // Helper function to get phone number
  const getPhoneNumber = (item: LedgerRecord) => {
    const phone = item.phones?.[0]?.phone;
    return phone && phone !== "undefined" ? phone : "No phone";
  };

  return (
    <div className="w-full overflow-y-auto max-h-[min(300px,40vh)]" id="ledger-header-table">
      {results.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            navigate(`/v1/ledger/${item.customerId}`);
            onClose();
          }}
          className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150"
        >
          <p className="flex-1 font-medium text-gray-800 text-sm truncate" id="ledger-header-table-name">
            {getFullName(item)}
          </p>
          <p className="text-gray-500 text-sm font-mono ml-4" id="ledger-header-table-phn">
            {getPhoneNumber(item)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default LedgerSearchDropdown;
